import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDota2Barrack = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		y: 3.89795,
		width: 15,
		height: 9.6,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 2.49976,
		y: 1.5,
		width: 10,
		height: 4.8,
		fill: "currentColor"
	})]
});
export default SvgDota2Barrack;
